'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGif = function MdGif(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 17.5h-5v1.6h3.4v2.5h-3.4v3.4h-2.5v-10h7.5v2.5z m-16.6-2.5c1 0 1.6 0.8 1.6 1.6v0.9h-5.7v5h3.2v-2.5h2.5v3.4c0 0.8-0.6 1.6-1.6 1.6h-5c-1 0-1.6-0.8-1.6-1.6v-6.8c0-0.8 0.6-1.6 1.6-1.6h5z m4.1 0h2.5v10h-2.5v-10z' })
        )
    );
};

exports.default = MdGif;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/gif.js
// module id = 1580
// module chunks = 168707334958949